const mediaQueries = {};
/* eslint-disable  no-undef */
export const initMediaQueryData = (queries) => {
  const keys = Object.keys(queries);
  const initialActionData = {};
  let mq;
  keys.forEach(
    (key) => {
      mq = matchMedia(`(min-width: ${queries[key].minWidth}px)`);
      initialActionData[key] = mq.matches;
    }
  );
  return initialActionData;
};

export const initMediaQueryListeners = (actionFunc, queries) => {
  const keys = Object.keys(queries);
  keys.forEach(
    (key) => {
      mediaQueries[key] = matchMedia(`(min-width: ${queries[key].minWidth}px)`);
      const listenerFunc = (mql) => (
        // updates the mediaQuery store in redux
        (actionFunc({ [key]: mql.matches }))
      );
      if (mediaQueries[key].addEventListener) {
        mediaQueries[key].addEventListener('change', listenerFunc);
      } else {
        mediaQueries[key].addListener(listenerFunc);
      }
    }
  );
};
